import { useSelector } from 'react-redux';
export const useExperiments = () => {
  return useSelector(state => state.experiments) || {};
};
export const useTreatments = () => {
  return useExperiments().treatments || {};
};
export const useTreatment = treatmentKey => useTreatments()[treatmentKey];